import { useParams, useLocation, Navigate } from "react-router-dom";
import ErrorBoundary from "@/components/ErrorBoundary";

export default function SectionIdLayout() {
  const { sectionId } = useParams();
  const { pathname, search } = useLocation();
  const isSettings = pathname.endsWith("/settings");

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  const settingsSuffix = isSettings ? "/settings" : "";
  return <Navigate to={`/sections/${sectionId}/people/change-requests${settingsSuffix}${search}`} replace />;
}
